.container {
  line-height: 2.4rem;
  color: var(--color-grayscale-light-slate);
  white-space: pre-line;
}
